class MagazineController {
    constructor() {
        this.setRecentSlider();
        if(document.getElementById('js-event-detail__slider')) {
            this.setMagazineDetailSlider();
        }
    }

    setRecentSlider() {
        let options = {
            loop: true,
            loopAdditionalSlides: 3,
            // loopedSlides: 5,
            // freeMode: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            spaceBetween: window.UA.isSP ? 28 : 40,
            slidesPerView: 'auto',
            // slidesPerGroup: 1,
            // navigation: {
            //     nextEl: '#js-home-voice__slider-next',
            //     prevEl: '#js-home-voice__slider-prev',
            // },
            // scrollbar: {
            //     el: '#js-home-voice__slider-bar',
            //     // hide: true,
            //     draggable: false,
            // },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };

        if ($('.home-voice__slider-item').length < 2) {
            options.centeredSlides = true;
        }
        let recentSlider = new Swiper(
            '#js-magazine-detail__recent-slider',
            options
        );
        if (window.UA.isSP) {
            recentSlider.off('resize');
        }
        let height = [];
        $('#js-magazine-detail__recent-slider .swiper-slide').each(function(){
            let $this = $(this);
            height.push($this.height());
        });
        $('#js-magazine-detail__recent-slider .swiper-slide').css({
            height: `${Math.max.apply(null, height)}px`
        });
    }

    setMagazineDetailSlider() {
        if ($('#js-event-detail__slider').length < 1) {
            $('.magazine-detail__eyecatch2-slider .swiper-slide').css({
                width: '100%',
            });
        }
        let beforeStatus = {};
        let thumbOptions = {
            spaceBetween: 16,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: false,
            preventClicks: false,
            preventClicksPropagation: false,
            preventInteractionOnTransition: false,
            // passiveListeners: false,
            allowTouchMove: true,
        };
        this.thumbSlider = new Swiper(
            '#js-event-detail__thumbnail',
            thumbOptions
        );
        //
        let options = {
            // loop: true,
            // loopAdditionalSlides: 1,
            // freeMode: true,
            // autoplay: {
            //     delay: 3000,
            //     disableOnInteraction: false
            // },
            // updateOnWindowResize: false,
            // centeredSlides: true,
            // centerInsufficientSlides: true,
            slidesPerView: 1,
            preventClicks: false,
            preventClicksPropagation: false,
            preventInteractionOnTransition: true,
            // slidesPerGroup: 1,
            // slideToClickedSlide: true,
            scrollbar: {
                el: '#js-event-detail__slider-bar',
                // hide: true,
                draggable: true,
            },
            touchAngle: 20,
            speed: 250,
            on: {
                beforeTransitionStart: () => {
                    if (this.mainSlider) {
                        if (
                            beforeStatus.index ===
                                this.mainSlider.activeIndex &&
                            beforeStatus.isEnd === this.mainSlider.isEnd
                        ) {
                            this.mainSlider.slideTo(0);
                        }
                        beforeStatus.index = this.mainSlider.activeIndex;
                        beforeStatus.isEnd = this.mainSlider.isEnd;
                    }
                },
            },
            thumbs: {
                swiper: this.thumbSlider,
            },
        };
        this.mainSlider = new Swiper('#js-event-detail__slider', options);
        if (window.UA.isSP) {
            this.mainSlider.off('resize');
        }
    }
}

export default MagazineController;
